import { ChangeDetectorRef, ViewRef } from '@angular/core';

export const asViewRef = (cdRef: ChangeDetectorRef) => <ViewRef>cdRef;

export const objectKeys = <T extends {}>(obj: T): (keyof T)[] => <(keyof T)[]>Object.keys(obj);
export const objectValues = <T, U extends keyof T>(obj: T) => <T[U][]>(<unknown>Object.values(obj));

export type SnakeToCamelCase<T extends string> = T extends `${infer W1}_${infer C1}${infer W2}`
  ? `${Lowercase<W1>}${Uppercase<C1>}${SnakeToCamelCase<W2>}`
  : Lowercase<T>;
